import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
/* eslint-disable @typescript-eslint/no-explicit-any */
export var Observer = /*#__PURE__*/function () {
  function Observer() {
    var _this = this;
    _classCallCheck(this, Observer);
    _defineProperty(this, "listeners", []);
    _defineProperty(this, "unsubscribed", []);
    _defineProperty(this, "on", function (listener) {
      var isSubscribed = _this.listeners.includes(listener);
      if (!isSubscribed) {
        _this.listeners.push(listener);
      }
      return function () {
        _this.scheduleUnsubscribe(listener);
      };
    });
    _defineProperty(this, "emit", function () {
      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }
      _toConsumableArray(_this.listeners).forEach(function (listener) {
        var isUnsubscribed = _this.unsubscribed.includes(listener);
        if (!isUnsubscribed) {
          listener.apply(void 0, args);
        }
      });
    });
    _defineProperty(this, "unsubscribeTimer", void 0);
  }
  return _createClass(Observer, [{
    key: "scheduleUnsubscribe",
    value: function scheduleUnsubscribe(listener) {
      var _this2 = this;
      this.unsubscribed.push(listener);
      this.listeners = this.listeners.filter(function (item) {
        return item !== listener;
      });
      clearTimeout(this.unsubscribeTimer);
      this.unsubscribeTimer = setTimeout(function () {
        _this2.unsubscribed = [];
      }, 0);
    }
  }]);
}();